import {
  useMutation,
} from '@tanstack/react-query'
import api  from '../../services/api';


export const useMacroStore = () => {

  return useMutation({
    mutationFn: async (body) => {
      const isFormData = body instanceof FormData;
      const res = await api.post(
        "/macros/store",
        body,
        isFormData
          ? { headers: { "Content-Type": "multipart/form-data" } }
          : undefined
      );
      return res.data;
    }
  });

};
